@if (formGroup) {
  <app-dropdown-control
    [fg]="formGroup"
    [formGroupOrControlName]="formGroupOrControlName"
    [label]="label"
    [options]="options"
    [multiple]="multiple"
    [noLabel]="noLabel"
    (onChange)="onChange($event)"
  ></app-dropdown-control>
}
